export const getStorage = session => (session ? sessionStorage : localStorage)
